"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.withV1PublicErrors = exports.withV1StandardErrors = exports.withPublicErrors = exports.withStandardErrors = exports.withErrors = exports.V1Public = exports.Public = exports.V1Standard = exports.Standard = exports.V1Internal = exports.V1RateLimit = exports.v1Rejected = exports.V1LegacyValidation = exports.V1LegacyParamValidation = exports.V1Conflict = exports.V1NotFound = exports.V1Forbidden = exports.V1NotAuthorized = exports.V1NotAuthenticated = exports.Internal = exports.RateLimit = exports.Conflict = exports.NotFound = exports.Forbidden = exports.NotAuthorized = exports.NotAuthenticated = exports.LegacyValidation = exports.Validation = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const json_1 = require("../../../json");
const Protocol = __importStar(require("../v2/protocol"));
const V2Error = __importStar(require("../v2/spec/error"));
exports.NAMESPACE = 'Culligan.Api.OpenApi.Error';
/*
 * Two wire formats.
 *
 * Typed v2 endpoints answer `{ success: false, error: { type, message, ... } }`.
 * The aliases below (`Validation`, `NotAuthenticated`, ...) are those schemas.
 * The same schema *object* is reused everywhere on purpose: `OpenApi.fromApi`
 * keys `components.schemas` by identifier, so every document contains each
 * error component exactly once.
 *
 * v1 Express routes answer through `libraries/protocol/v1`, which sends
 * `{ success: false, error: { message, ... } }` and never sets `error.type`.
 * The `V1*` schemas describe that body. v1 specs use them; the aliases above
 * stay for the typed protocol.
 */
const v1Message = effect_1.Schema.String.annotations({
    description: 'Machine-readable v1 error code, such as INVALID_TOKEN or INVALID_REQUEST.',
});
const v1Failure = (name, status, error, title, description) => effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error,
}).annotations({
    identifier: `${exports.NAMESPACE}.${name}`,
    title,
    description,
    [platform_1.HttpApiSchema.AnnotationStatus]: status,
});
const v1MessageError = effect_1.Schema.Struct({ message: v1Message });
/** 400: the request does not satisfy validation rules (typed endpoints format). */
exports.Validation = V2Error.ValidationErrorFromProtocol;
/** 422: the request does not satisfy validation rules (legacy `express-validator` format). */
exports.LegacyValidation = V2Error.LegacyValidationErrorFromProtocol;
/** 401: no (valid) credentials were presented. */
exports.NotAuthenticated = V2Error.NotAuthenticatedErrorFromProtocol;
/** 401: credentials are valid but the actor may not perform the request. */
exports.NotAuthorized = V2Error.NotAuthorizedErrorFromProtocol;
/** 403: the actor lacks the role a guard requires. */
exports.Forbidden = V2Error.ForbiddenErrorFromProtocol;
/** 404: the resource does not exist. */
exports.NotFound = V2Error.NotFoundErrorFromProtocol;
/** 409: creating or updating the entity conflicts with an existing one. */
exports.Conflict = V2Error.EntityExistsErrorFromProtocol;
/** 429: the caller exceeded a rate limit. */
exports.RateLimit = V2Error.TooManyRequestsErrorFromProtocol;
/** 500: the request failed for reasons unrelated to its content. */
exports.Internal = V2Error.InternalServerErrorFromProtocol;
/** 401: no valid credentials. Body is `{ message }`, typically `INVALID_TOKEN`. */
exports.V1NotAuthenticated = v1Failure('V1NotAuthenticated', 401, v1MessageError, 'Not Authenticated', 'The caller presented no valid credentials.');
/** 401: credentials are valid but the actor may not perform the request. Typically `INVALID_CREDENTIALS`. */
exports.V1NotAuthorized = v1Failure('V1NotAuthorized', 401, v1MessageError, 'Not Authorized', 'The authenticated caller may not perform the request.');
/** 403: the caller is authenticated but lacks the required role. Typically `NOT_ALLOWED`. */
exports.V1Forbidden = v1Failure('V1Forbidden', 403, v1MessageError, 'Forbidden', 'The authenticated caller lacks the role a guard requires.');
/** 404: the resource does not exist. Typically `NOT_FOUND`. */
exports.V1NotFound = v1Failure('V1NotFound', 404, v1MessageError, 'Not Found', 'The requested resource could not be found.');
/** 409: the entity already exists. Typically `ITEM_EXISTS`. */
exports.V1Conflict = v1Failure('V1Conflict', 409, v1MessageError, 'Conflict', 'Creating or updating the entity conflicts with an existing one.');
/**
 * express-validator 6 field error as v1 sends it.
 * A missing field is reported with `value: undefined`, and JSON drops that key,
 * so `value` is optional. {@link Protocol.LegacyParamValidation} still requires it for v2.
 */
exports.V1LegacyParamValidation = effect_1.Schema.Struct({
    ...Protocol.LegacyParamValidation.fields,
    value: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.V1LegacyParamValidation`,
    description: 'express-validator field error. `value` is omitted when the rejected field was missing.',
});
const V1LegacyInputValidation = effect_1.Schema.Union(Protocol.LegacyChainValidation, exports.V1LegacyParamValidation);
/**
 * 422: `express-validator` rejected the request.
 * `message` is an error code such as `INVALID_REQUEST`; `inputValidation` holds the field errors.
 */
exports.V1LegacyValidation = v1Failure('V1LegacyValidation', 422, effect_1.Schema.Struct({
    message: v1Message,
    inputValidation: effect_1.Schema.Array(V1LegacyInputValidation),
}), 'Validation Error', 'One of the request entities does not satisfy validation rules.');
/*
 * 422 with no `inputValidation`. Some v1 controllers reject a request that
 * express-validator already accepted and answer `{ message }` alone, sometimes
 * with extra fields such as `reason`. {@link V1LegacyValidation} requires
 * `inputValidation`, so it cannot describe that body.
 *
 * Define it next to the endpoint. `identifier` is the full component name
 * (`${NAMESPACE}.Name`): each call pins one message, so routes that reject
 * differently stay different components.
 */
const v1Rejected = (identifier, message, title, description, fields) => effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({
        message: effect_1.Schema.Literal(message),
        ...fields,
    }),
}).annotations({
    identifier,
    title,
    description,
    [platform_1.HttpApiSchema.AnnotationStatus]: 422,
});
exports.v1Rejected = v1Rejected;
/** 429: the caller exceeded a rate limit. Typically `TOO_MANY_REQUESTS`. */
exports.V1RateLimit = v1Failure('V1RateLimit', 429, v1MessageError, 'Too Many Requests', 'A rate limit applies to the request.');
/** 500: the request failed for reasons unrelated to its content. Typically `UNKNOWN_ERROR`. */
exports.V1Internal = v1Failure('V1Internal', 500, v1MessageError, 'Internal Server Error', 'Something went wrong while processing the request.');
/** Typed v2 errors every guarded route can answer with, regardless of its business logic. */
exports.Standard = [
    exports.Validation,
    exports.NotAuthenticated,
    exports.Forbidden,
    exports.RateLimit,
    exports.Internal,
];
/**
 * v1-protocol errors every guarded Express route can answer with, regardless of its business logic.
 *
 * Validation failures are not in this set: v1 reports them as 422 {@link V1LegacyValidation},
 * which each endpoint adds itself.
 */
exports.V1Standard = [
    exports.V1NotAuthenticated,
    exports.V1Forbidden,
    exports.V1RateLimit,
    exports.V1Internal,
];
/** Errors every public (unguarded) legacy route can answer with: no 401/403. */
exports.Public = [exports.Validation, exports.RateLimit, exports.Internal];
/**
 * v1 counterpart of {@link Public}: 429 and 500, no 401/403. As with {@link V1Standard},
 * an endpoint that validates its input adds the 422 itself.
 */
exports.V1Public = [exports.V1RateLimit, exports.V1Internal];
/** Adds several error schemas to an endpoint at once. */
const withErrors = (errors) => (endpoint) => errors.reduce((acc, error) => acc.addError(error), endpoint);
exports.withErrors = withErrors;
/**
 * Adds the {@link Standard} errors to an endpoint.
 *
 * Endpoint-specific errors (404, 409, ...) are added by the endpoint itself.
 */
exports.withStandardErrors = (0, exports.withErrors)(exports.Standard);
/** Adds the {@link Public} errors to an endpoint. */
exports.withPublicErrors = (0, exports.withErrors)(exports.Public);
/** Adds the {@link V1Standard} errors to an endpoint. */
exports.withV1StandardErrors = (0, exports.withErrors)(exports.V1Standard);
/** Adds the {@link V1Public} errors to an endpoint. */
exports.withV1PublicErrors = (0, exports.withErrors)(exports.V1Public);
//# sourceMappingURL=error.js.map